/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { FormattedHTMLMessage } from 'react-intl';

// Styles
import './styles/FacebookLogin.scss';

// Messages
import messages from './messages/FacebookLogin_messages';

const propTypes = {
  facebook: PropTypes.object.isRequired,
  appId: PropTypes.string.isRequired,
  onLogin: PropTypes.func.isRequired,
};

class FacebookLogin extends PureComponent {
  componentDidMount() {
    this.props.facebook.init({
      appId: this.props.appId,
      cookie: true,
      status: true,
      version: 'v2.6',
    });

    this.props.facebook.getLoginStatus(response => {
      if (response.status === 'connected') {
        this.props.onLogin({
          provider: 'facebook',
          token: response.authResponse.accessToken,
        });
      }
    });
  }

  onLogout(response) {
    console.debug(response);
    // TODO: do something?
  }

  _onLoginClick = event => {
    event.preventDefault();
    this.props.facebook.login(
      response => {
        if (!response.authResponse) {
          return;
        }

        this.props.onLogin({
          provider: 'facebook',
          token: response.authResponse.accessToken,
        });
      },
      {
        scope: 'public_profile,email',
      }
    );
  };

  render() {
    // TODO: configure the button
    return (
      <div styleName="FacebookLogin">
        <a
          styleName="button"
          style={{ marginTop: 10 }}
          onClick={this._onLoginClick}
        >
          <div styleName="button-text">
            <i className="fa fa-facebook-official" styleName="icon" />
            <FormattedHTMLMessage
              {...messages.loginButton}
              info="Login button"
            />
          </div>
        </a>
      </div>
    );
  }
}

FacebookLogin.propTypes = propTypes;

export default FacebookLogin;
